import React from "react";
import styled from "styled-components";
import UpdateItem from "src/core/checkout/components/UpdateItem";
import {TrashIcon} from "src/core/common/components/elements/icon/TrashIcon";

function RemoveItemButton({item}) {
  return (
    <UpdateItem
      item={item}
      render={({removeItem}) => (
        <DeleteButtonContainer onClick={removeItem}>
          <SmallTrashIcon onClick={removeItem} />
        </DeleteButtonContainer>
      )}
    />
  );
}

const SmallTrashIcon = styled(TrashIcon)`
  height: 14px;
  width: 14px;
`;
const DeleteButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 35px;
  width: 35px;
  border-radius: ${({theme}) => theme.v2.decoration.border.radius.default};
  background-color: #fdfefe;
  border: 1px solid #f0f5f6;

  &:active {
    color: ${({theme}) => theme.v2.color.primary};
  }
`;

export default RemoveItemButton;
